import Situacao from "./Situacao";
import Perfil from "./Perfil";
import TipoContato from "./TipoContato";
import TipoContaBancaria from "./TipoContaBancaria";
import Parcelas from "./Parcelas";
import Taxa from "./Taxa";
import Estados from "./Estados";
import Meses from "./Meses";
import QuantidadeCartoes from "./QuantidadeCartoes";
import TipoPagamento from "./TipoPagamento";
import NrCartoes from "./NrCartoes";
import Anos from "./Anos";
import StatusWebHook from "./StatusWebHook";
import Token from "./Token";
import Adquirente from "./Adquirente";
import AdquirenteImagem from "./AdquirenteImagem";
import AdquirenteCodigo from "./AdquirenteCodigo";
import AdquirenteFiltro from "./AdquirenteFiltro";
import Plataforma from "./Plataforma";
import PlataformaFiltro from "./PlataformaFiltro";
import Ligado from "./Ligado";
import SimNao from "./SimNao";
import BaseJuros from "./BaseJuros";

export default {
  Situacao,
  Perfil,
  TipoContato,
  TipoContaBancaria,
  Parcelas,
  Taxa,
  Estados,
  Meses,
  QuantidadeCartoes,
  TipoPagamento,
  NrCartoes,
  Anos,
  StatusWebHook,
  Token,
  Adquirente,
  AdquirenteImagem,
  AdquirenteCodigo,
  AdquirenteFiltro,
  Plataforma,
  PlataformaFiltro,
  Ligado,
  SimNao,
  BaseJuros,
  //Buscar enum pelo value
  getEnum(v) {
    let Enum = [
      ...Situacao,
      ...Perfil,
      ...TipoContato,
      ...TipoContaBancaria,
      ...Parcelas,
      ...Taxa,
      ...Estados,
      ...Meses,
      ...QuantidadeCartoes,
      ...TipoPagamento,
      ...NrCartoes,
      ...Anos,
      ...StatusWebHook,
      ...Token,
      ...Adquirente,
      ...AdquirenteImagem,
      ...AdquirenteCodigo,
      ...AdquirenteFiltro,
      ...Plataforma,
      ...PlataformaFiltro,
      ...Ligado,
      ...SimNao,
      ...BaseJuros
    ];
    if (v == -1) return { value: -1, text: "Total" };
    return Enum.find((el) => el.value == v);
  },
};
